import { act } from "react-dom/test-utils";
import { actionTypes } from "../utils";

export const types = {
  // ...actionTypes('TRIGGER_LOADING'),
  ...actionTypes('SEND_EMAIL'),  
  ...actionTypes('GET_APP_CONFIG'),
  ...actionTypes('UPDATE_APP_CONFIG'),
  ...actionTypes('RESTORE_APP_CONFIG'),
  ...actionTypes('CLEAR_CONFIG_ERROR'),
  ...actionTypes('GENERATE_IDS'),
  ...actionTypes('FIX_IDS'),
  ...actionTypes('SET_VARIABLE'),
};